export default "__VITE_ASSET__6d268afe__"